import { useState } from "react";
import { Select } from "antd";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import "./company.css";
import CompanyMain from "./company-main";
import CompanyBases from "./company-bases";
import CompanyConditions from "./company-conditions";
import CompanyTokens from "./company-tokens";
import CompanyUsers from "./company-users";
import CompanyBackups from "./company-backups";

const COMPANY_SECTIONS = [
  { id: 1, label: "Компания" },
  { id: 2, label: "Базы" },
  { id: 3, label: "Пользователи" },
  { id: 4, label: "Маршруты обмена" },
  { id: 6, label: "Интеграция" },
  { id: 8, label: "Резервные копии" },
];

const Company = () => {
  const [selectedPage, setSelectedPage] = useState(1);
  const viewport = useViewportBreakpoint();
  const isMobile = viewport === "mobile";

  const divPagesSelect = COMPANY_SECTIONS.map(({ id, label }) => (
    <div
      key={id}
      onClick={() => setSelectedPage(id)}
      className={selectedPage === id ? "page-selected" : ""}
    >
      {label}
    </div>
  ));

  const getPage = () => {
    switch (selectedPage) {
      case 1:
        return <CompanyMain />;
      case 2:
        return <CompanyBases />;
      case 3:
        return <CompanyUsers />;
      case 4:
        return <CompanyConditions />;
      case 6:
        return <CompanyTokens />;
      case 8:
        return <CompanyBackups />;
      default:
        return null;
    }
  };

  return (
    <div className="page company-page">
      {isMobile ? (
        <Select
          className="company-page-nav-select"
          size="large"
          value={selectedPage}
          options={COMPANY_SECTIONS.map(({ id, label }) => ({ value: id, label }))}
          onChange={setSelectedPage}
          popupMatchSelectWidth
        />
      ) : (
        <div className="page-select">{divPagesSelect}</div>
      )}
      {getPage()}
    </div>
  );
};

export default Company;
